import { useEffect, useRef } from "react";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import { useForm } from "react-hook-form";
import useModal from "../../hooks/useModal";
import { PaymentsService } from "../../services/PaymentsService";
import { AlertService } from "../../services/Alert";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
interface OpenPayModalProps {
    show: boolean;
    is_active: boolean;
    data: any;
    onRequestClose: (reload: boolean) => void;
}

function OpenPayModal({ show, is_active,  data, onRequestClose }: OpenPayModalProps) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    
    const modalSubRef = useRef<HTMLDivElement>(null);
    
    useModal(modalSubRef, show)

    const defaultValues = {
        account_id: account.id,
        is_default_payment: false,
        id: '',
        private_key: '',
        public_key: '',
    }

    const { register, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        // reset(defaultValues);
    }

    const submit = async(data) => {
        try {
            await PaymentsService.saveOpenPaySettings(data)
            await closeAndReset(true);
            AlertService.toastSuccess('Se guardo correctamente la configuración')
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
        }
    }


    useEffect(() => {
        if (data) {
            reset({
                account_id: account.id,
                is_default_payment: is_active,
                id: data.id,
                private_key: data.private_key,
                public_key: data.public_key,
            })
        }
    }, [data])

    
    return (
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">

                        <div className="modal-body">
                            <div className="mb-3">
                                <img src="https://v3.ws-voices.com.mx/assets/img/openpay-logo.png" className="img-fluid"/>
                            </div>
                            <div className="mb-3">
                                <Input label={t("platform.payments.openpay.id")} errors={errors.id} {...register('id', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>
                            <div className="mb-3">
                                <Input label={t("platform.payments.openpay.private-key")} errors={errors.private_key} {...register('private_key', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>
                            <div className="mb-3">
                                <Input label={t("platform.payments.openpay.public-key")} errors={errors.public_key} {...register('public_key', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            <div className="form-check form-switch mb-4">
                                <input type="checkbox" className="form-check-input" id={'is_default_payment'} {...register(`is_default_payment`)}  />
                                <label className="form-check-label" htmlFor={'is_default_payment'}>{t("platform.payments.openpay.default")}</label>
                            </div>
                            
                            

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default OpenPayModal